import { Injectable } from '@angular/core';
import { Locations } from '@cargos/sprintpay-models';
import { FacilityInformationType, LocationsService } from '@cargos/sprintpay-services';
import { BehaviorSubject, Observable, map, of } from 'rxjs';
import { CurrentFacilityService } from './current-facility.service';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    private _locations: BehaviorSubject<FacilityInformationType[] | null> = new BehaviorSubject<
        FacilityInformationType[] | null
    >(null);

    constructor(
        private locationsService: LocationsService,
        private currentFacilityService: CurrentFacilityService
    ) {}

    getCustomerLocations(): Observable<Locations> {
        return this.locationsService.getCustomerLocations();
    }

    getFacilityLocation$(): Observable<FacilityInformationType[] | null> {
        return this._locations.asObservable();
    }

    setFacilityLocation(information: FacilityInformationType[]): void {
        this._locations.next(information);
    }

    getFacilityLocations(): Observable<FacilityInformationType[]> {
        const sourceId = this.currentFacilityService.getSourceId();

        if (!sourceId) {
            return of([]);
        }

        return this.locationsService.getFacilityLocations(sourceId).pipe(
            map((information) => {
                this.setFacilityLocation(information);
                return information;
            })
        );
    }
}
